import _ from 'lodash';
import { CURRENCIES } from '@linearb/linjs-common';
import { StyledCurrenciesDropdown } from './CurrenciesDropdown.style';
import Dropdown from 'components/base/Dropdown';

const CurrenciesDropdown = ({
  onChange,
  value = CURRENCIES.USD.key,
  disabled
}) => {
  const currenciesOptions = _.map(CURRENCIES, currency => ({
    value: currency.key,
    displayValue: `${currency.symbol} ${currency.key}`
  }));

  return (
    <StyledCurrenciesDropdown>
      <Dropdown
        options={currenciesOptions}
        onChange={onChange}
        selectedValue={value}
        disabled={disabled}
      />
    </StyledCurrenciesDropdown>
  );
};

export default CurrenciesDropdown;
